import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from './ui/dialog';
import { Button } from './ui/button';
import { Lock } from 'lucide-react';

export default function DemoUpgradePrompt({ isOpen, onClose, featureName = 'this feature' }) {
  const navigate = useNavigate();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[420px] bg-white" data-testid="demo-upgrade-prompt">
        <DialogHeader>
          <div className="flex flex-col items-center gap-3 pt-2">
            <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
              <Lock className="w-6 h-6 text-amber-600" />
            </div>
            <DialogTitle className="text-lg font-semibold text-gray-900 text-center">
              Feature Restricted in Demo
            </DialogTitle>
          </div>
        </DialogHeader>
        <div className="py-3 text-center">
          <p className="text-sm text-gray-600">
            <span className="font-medium text-gray-800">{featureName}</span> is not available in the public demo.
          </p>
          <p className="text-sm text-gray-500 mt-2">
            Create a free account to unlock all features and manage your own workspace.
          </p>
        </div>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 sm:gap-3">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto" data-testid="demo-upgrade-dismiss-btn">
            Got it
          </Button>
          <Button
            onClick={() => { onClose(); navigate('/login'); }}
            className="w-full sm:w-auto bg-teal-500 hover:bg-teal-600 text-white"
            data-testid="demo-upgrade-signup-btn"
          >
            Sign Up for Free
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
